/**
 * @generated SignedSource<<da9335d1fa3db41d5d77b3d041b0e66b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JpdProjectMenuLoader_project$data = {
  readonly id: string;
  readonly isFavourite: boolean | null;
  readonly projectKey: string;
  readonly projectType: JiraProjectType;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExpandableMenuItem">;
  readonly " $fragmentType": "JpdProjectMenuLoader_project";
};
export type JpdProjectMenuLoader_project$key = {
  readonly " $data"?: JpdProjectMenuLoader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"JpdProjectMenuLoader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JpdProjectMenuLoader_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectType"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "FragmentSpread",
      "name": "ProjectExpandableMenuItem"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c174cdb45912f322052132f5018e2639";

export default node;
